/*
 * olv-promo-countdown.js
 * ──────────────────────
 * Web-Component <olv-promo-bar> für den Aktions-Banner. Die Section
 * sitzt als Group-Section zwischen `trust-bar` und `header` in der
 * header-group und erbt Layout 1:1 vom Header-Group-DOM-Flow — kein
 * Custom-Positioning, kein Sticky-Offset. Das JS steuert nur:
 *
 *   1. Sichtbarkeit anhand `data-start` / `data-end`
 *      (ISO-Timestamps mit Shop-Timezone-Offset). Bar startet mit
 *      `hidden` (no-JS-safe) und wird eingeblendet, wenn `now` im
 *      Fenster liegt. Nach `end` bleibt sie versteckt.
 *   2. Countdown im 1-Sekunden-Rhythmus, absolut aus `Date.now()`
 *      gerechnet (kein Dekrement-Drift).
 */
(function () {
  'use strict';

  function pad(n) {
    return (n < 10 ? '0' : '') + n;
  }

  var OlvPromoBar = class extends HTMLElement {
    connectedCallback() {
      var startAttr = this.getAttribute('data-start') || '';
      var endAttr   = this.getAttribute('data-end')   || '';

      /* Timestamps als absolute Ms. Ungültiges/leeres Datum → null
         (Auto-Fenster-Bedingung entfällt für diese Seite). */
      this._startMs = startAttr ? Date.parse(startAttr) : null;
      this._endMs   = endAttr   ? Date.parse(endAttr)   : null;
      if (isNaN(this._startMs)) this._startMs = null;
      if (isNaN(this._endMs))   this._endMs   = null;

      this._countdownEnabled = this.getAttribute('data-countdown-enabled') === 'true' && this._endMs !== null;

      this._timerId       = null;   // 1-Sekunden-Tick fuer Countdown
      this._visibilityId  = null;   // 1-Minuten-Tick fuer Start-Zeitpunkt

      this._dEl = this.querySelector('[data-d]');
      this._hEl = this.querySelector('[data-h]');
      this._mEl = this.querySelector('[data-m]');
      this._sEl = this.querySelector('[data-s]');

      this._evaluate();

      /* Fenster-Start pollen (nur ausserhalb des Fensters). Sobald
         die Bar sichtbar wird, uebernimmt der Sekunden-Tick des
         Countdowns die weitere Auswertung. */
      this._visibilityId = setInterval(this._evaluate.bind(this), 60000);
    }

    disconnectedCallback() {
      this._stopTick();
      if (this._visibilityId) {
        clearInterval(this._visibilityId);
        this._visibilityId = null;
      }
    }

    _evaluate() {
      var now = Date.now();
      var withinStart = (this._startMs === null) || now >= this._startMs;
      var beforeEnd   = (this._endMs   === null) || now <  this._endMs;

      if (withinStart && beforeEnd) {
        this._show();
      } else {
        this._hide();
        /* Nach Ende: alles definitiv beenden. */
        if (!beforeEnd && this._visibilityId) {
          clearInterval(this._visibilityId);
          this._visibilityId = null;
        }
      }
    }

    _show() {
      if (!this.hasAttribute('hidden') && this._timerId) return;
      this.removeAttribute('hidden');
      if (this._countdownEnabled) {
        this._tick(); // sofortiges Rendering, dann alle 1000 ms
        this._timerId = setInterval(this._tick.bind(this), 1000);
      }
    }

    _hide() {
      if (this.hasAttribute('hidden') && !this._timerId) return;
      this.setAttribute('hidden', '');
      this._stopTick();
    }

    _stopTick() {
      if (this._timerId) {
        clearInterval(this._timerId);
        this._timerId = null;
      }
    }

    _tick() {
      if (this._endMs === null) return;
      var diff = this._endMs - Date.now();
      if (diff <= 0) {
        this._hide();
        return;
      }
      var s = Math.floor(diff / 1000);
      var d = Math.floor(s / 86400); s -= d * 86400;
      var h = Math.floor(s / 3600);  s -= h * 3600;
      var m = Math.floor(s / 60);    s -= m * 60;
      if (this._dEl) this._dEl.textContent = pad(d);
      if (this._hEl) this._hEl.textContent = pad(h);
      if (this._mEl) this._mEl.textContent = pad(m);
      if (this._sEl) this._sEl.textContent = pad(s);
    }
  };

  if (!window.customElements.get('olv-promo-bar')) {
    window.customElements.define('olv-promo-bar', OlvPromoBar);
  }
})();
